import React from 'react';

interface LoadingProps {
  fullScreen?: boolean;
  message?: string;
}

const Loading: React.FC<LoadingProps> = ({
  fullScreen = true,
  message = 'Loading...',
}) => {

  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-6 bg-white">

        {/* Logo: Hegravision
          - Uses 'items-baseline' to ensure 'Hegra' and 'vision' align perfectly.
          - 'vision' is in a flex-col to stack the text and the bar.
        */}
        <div className="flex items-baseline text-5xl font-bold">
          
          {/* Hegra part (static) */}
          <span className="text-red-600">Hegra</span>
          
          {/* Vision part (contains text and loading bar) */}
          <div className="flex flex-col" style={{ minWidth: '140px' }}>
            <span className="text-gray-900">vision</span>
            
            {/* Red loading line container (width matches 'vision' text) */}
            <div className="relative w-full h-1.5 mt-1 overflow-hidden" style={{ minHeight: '6px' }}> 
              {/* The animated line itself */}
              <div 
                className="absolute left-0 bg-red-600 h-full animate-[loadLine_1.5s_ease-in-out_infinite]"
              ></div>
            </div>
          </div>
        </div>

        {/* Loading Message */}
        <p className="text-gray-600 text-lg font-medium mt-4 animate-pulse">{message}</p>

        {/* Custom Keyframes for the animation */}
        <style>
          {`
          @keyframes loadLine {
            0% {
              width: 0%;
              left: 0%;
              opacity: 1;
            }
            50% {
              width: 100%;
              left: 0%;
              opacity: 1;
            }
            100% {
              width: 0%;
              left: 100%;
              opacity: 0;
            }
          }
          `}
        </style>
      </div>
    );
  }

  // Inline Loading (for components) - Kept simple
  return (
    <div className="flex items-center justify-center gap-3 py-12">
      <div className="relative w-8 h-8">
        <div className="absolute inset-0 border-4 border-gray-200 rounded-full"></div>
        <div className="absolute inset-0 border-4 border-transparent border-t-red-600 rounded-full animate-spin"></div>
      </div>
      <p className="text-gray-600 font-medium">{message}</p>
    </div>
  );
};

export default Loading;